module.exports = __webpack_public_path__ + "img/shop-img-3.c009baf4.png";